import { writable } from 'svelte/store';
import { lettersWithItemsStore } from './letters-with-items';

export const fullAlphabet = Array.from('abcdefghijklmnopqrstuvwxyz');

const getDefaultState = () => {
    return {
        active: 'a',
        letters: fullAlphabet.map((letter) => {
            return {
                letter,
                isActive: letter === 'a',
            };
        }),
    };
};

const START_WITH_FIRST_LETTER_FILTER = false;

class AlphabetStore {
    constructor() {
        this.setActiveLetter = this.setActiveLetter.bind(this);

        const defaultState = getDefaultState();
        this.store = writable(defaultState);

        this.internalState = {};
        this.store.subscribe((state) => {
            this.internalState = state;
        });

        lettersWithItemsStore.subscribe((letters) => {
            if (START_WITH_FIRST_LETTER_FILTER) {
                this.setActiveLetter(letters[0]);
            } else {
                this.unsetAlphabetSearch();
            }
        });
    }

    setActiveLetter(letter) {
        if (letter !== this.internalState.active) {
            this.store.update((state) => {
                const letters = state.letters.map((currentLetter) => {
                    return {
                        ...currentLetter,
                        isActive: currentLetter.letter === letter,
                    };
                });

                return {
                    ...state,
                    active: letter,
                    letters,
                };
            });
        }
    }

    unsetAlphabetSearch() {
        this.store.update((state) => {
            const letters = state.letters.map((letter) => {
                return {
                    ...letter,
                    isActive: false,
                };
            });

            return {
                ...state,
                active: null,
                letters,
            };
        });
    }

    get subscribe() {
        return this.store.subscribe;
    }
}

export const alphabetStore = new AlphabetStore();
